export default __webpack_public_path__ + "static/media/calendar.fbb8aa8a.png";